import React from 'react';
import { Modal } from '../../../../Modal';
import { MaterialList } from '../MaterialList/MaterialList';
import { Button } from '../../../../Button';
import Link from '../../../../Typography/components/Link';
import { Input } from '../../../../Input';
import { Refresh, Search, CloseOne } from '@tencent/adp-icons-react';
import { Spin } from '../../../../Spin';
import { usePrefixCls } from '../../../../../config/hooks/usePrefixCls';
import { CREATIVE_MATERIAL_LIBRARY } from '../../common/const';
import { ImageItem } from '../ImageItem';
export var MaterialPanel = function MaterialPanel(props) {
  var show = props.show,
    panelStyleConfig = props.panelStyleConfig,
    onOk = props.onOk,
    onCancel = props.onCancel,
    isLoading = props.isLoading,
    max = props.max,
    _props$headerOps = props.headerOps,
    searchValue = _props$headerOps.searchValue,
    onSearchValueChange = _props$headerOps.onSearchValueChange,
    materialHint = _props$headerOps.materialHint,
    onRefresh = _props$headerOps.onRefresh,
    uploadLocalFile = _props$headerOps.uploadLocalFile,
    _props$listOps = props.listOps,
    _props$listOps$list = _props$listOps.list,
    list = _props$listOps$list === void 0 ? [] : _props$listOps$list,
    _props$listOps$upload = _props$listOps.uploadList,
    uploadList = _props$listOps$upload === void 0 ? [] : _props$listOps$upload,
    _props$listOps$active = _props$listOps.activeImages,
    activeImages = _props$listOps$active === void 0 ? [] : _props$listOps$active,
    setActiveImages = _props$listOps.setActiveImages,
    total = _props$listOps.total,
    currentPage = _props$listOps.currentPage,
    onPageChange = _props$listOps.onPageChange,
    retryUpload = _props$listOps.retryUpload;
  var cls = usePrefixCls('material-library-multiple-image-panel');
  var headerCls = "".concat(cls, "-header");
  return React.createElement(React.Fragment, null, React.createElement(Modal, {
    show: show,
    onOk: onOk,
    bodyStyle: {
      width: (panelStyleConfig === null || panelStyleConfig === void 0 ? void 0 : panelStyleConfig.panelWidth) || 900
    },
    onCancel: onCancel,
    maskClosable: false,
    title: "\u9009\u62E9\u7D20\u6750"
  }, React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: headerCls
  }, React.createElement("div", {
    className: "".concat(headerCls, "-option")
  }, React.createElement("div", null, React.createElement(Button, {
    type: "primary",
    onClick: uploadLocalFile
  }, "\u672C\u5730\u4E0A\u4F20"), React.createElement(Link, {
    className: "".concat(headerCls, "-option-material-link"),
    target: "_blank",
    href: CREATIVE_MATERIAL_LIBRARY
  }, "\u524D\u5F80\u7D20\u6750\u5E93")), React.createElement(Input, {
    className: "".concat(headerCls, "-option-material-query"),
    prefix: React.createElement(Search, {
      className: "".concat(headerCls, "-option-input-icon"),
      size: 16
    }),
    placeholder: "\u8BF7\u8F93\u5165\u7D20\u6750\u540D\u79F0",
    value: searchValue,
    onValueChange: onSearchValueChange
  })), React.createElement("div", {
    className: "".concat(headerCls, "-reload-section")
  }, materialHint, React.createElement("i", {
    className: "".concat(headerCls, "-text-btn"),
    onClick: onRefresh
  }, React.createElement(Refresh, {
    size: 14,
    style: {
      marginRight: 6
    }
  }), "\u5237\u65B0"))), React.createElement("div", {
    className: "".concat(cls, "-list"),
    style: {
      minHeight: (panelStyleConfig === null || panelStyleConfig === void 0 ? void 0 : panelStyleConfig.panelHeight) || 514
    }
  }, React.createElement(Spin, {
    wrapperClassName: "".concat(cls, "-loading-wrapper"),
    className: "".concat(cls, "-loading"),
    spinning: isLoading
  }, React.createElement(MaterialList, {
    isLoading: isLoading,
    uploadList: uploadList,
    retryUpload: retryUpload,
    panelStyleConfig: panelStyleConfig,
    list: list,
    activeImages: activeImages,
    onActiveChange: setActiveImages,
    totalSize: total,
    pageValue: currentPage,
    onPageChange: onPageChange,
    max: max
  }))), React.createElement("div", {
    className: "".concat(cls, "-selected-bar")
  }, React.createElement("div", {
    style: {
      marginRight: 16
    }
  }, "\u5DF2\u9009 ", React.createElement("span", {
    className: 'selected'
  }, activeImages.length), "/", max, " \u4E2A"), activeImages.map(function (item, index) {
    return React.createElement("div", {
      key: index,
      className: 'small-thumbnail'
    }, React.createElement(ImageItem, {
      value: item
    }), React.createElement(CloseOne, {
      className: 'remove',
      fill: '#000000',
      onClick: function onClick() {
        var newActiveImages = activeImages.filter(function (_ref) {
          var materialId = _ref.materialId;
          return item.materialId !== materialId;
        });
        setActiveImages(newActiveImages);
      }
    }));
  })))));
};